import {ReadSensorGpsTime_ReadSensorGpsTimeResponse} from "../../../../api";
import {
  ReadSensorCoords_ReadSensorCoordsResponse,
  ReadSensorParams_ReadSensorParamsResponse,
} from "../../../../api";
import {SensorBlockModelProps} from "../../../../models/SensorBlock.model";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import UpdateButton from "../../../shared/UpdateButton/UpdateButton";
import {SensorBlockApi} from "../../../../services/SensorBlock.api";
import NotificationFactory from "../../../../shared/Notifications";
import {Input, InputGroup, toaster, Whisper} from "rsuite";
import GearIcon from "@rsuite/icons/Gear";
import StatusControl from "../../../shared/StatusControl/StatusControl";
import {gpsStatus, setStatus} from "../../ExternalDevices/components/Dimmer/utils/Dimmer.utils";
import CopyIcon from "@rsuite/icons/Copy";
import {SensorBlockUtils} from "../../ExternalDevices/components/SensorBlock/SensorBlock.utils";
import {getTooltip} from "../../../../shared/Tooltip";
import moment from "moment";

const SensorBlockSection = ({sensor, deviceId}: SensorBlockModelProps) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [params, setParams] = useState<ReadSensorParams_ReadSensorParamsResponse | null>(null);
  const [gpsCoordinates, setGpsCoordinates] = useState<ReadSensorCoords_ReadSensorCoordsResponse | null>(null);
  const [gpsTime, setGpsTime] = useState<ReadSensorGpsTime_ReadSensorGpsTimeResponse>({});
  const [shockCounter, setShockCounter] = useState(0);
  const [openCounter, setOpenCounter] = useState(0);

  useEffect(() => {
    getParams().then();
    getGpsCoordinates().then();
    getGpsTime().then();
  }, [deviceId])

  const getParams = async () => {
    setLoading(true);
    try {
      const result: ReadSensorParams_ReadSensorParamsResponse = await SensorBlockApi.getSensorBlockParams(sensor?.id);

      setParams(result);

      setShockCounter(result?.doorShockCounter || 0);
      setOpenCounter(result?.doorOpenCounter || 0);

    } catch (error) {
      toaster.push(NotificationFactory.error("Ошибка"), {placement: "topEnd"});
    } finally {
      setLoading(false);
    }
  };

  const getGpsCoordinates = async () => {
    setLoading(true);
    try {
      const result = await SensorBlockApi.getSensorBlockGpsCoordinates(sensor?.id);
      setGpsCoordinates(result);
    } catch (error) {
      toaster.push(NotificationFactory.error("Ошибка"), {placement: "topEnd"});
    } finally {
      setLoading(false);
    }
  };

  const getGpsTime = async () => {
    setLoading(true);
    try {
      const result = await SensorBlockApi.getSensorBlockGpsTime(sensor?.id);
      setGpsTime(result);
    } catch (error) {
      toaster.push(NotificationFactory.error("Ошибка"), {placement: "topEnd"});
    } finally {
      setLoading(false);
    }
  };

  const formattedGpsTime = gpsTime?.time
    ? moment(gpsTime.time).isValid()
      ? moment(gpsTime.time).format("DD.MM.YYYY HH:mm:ss")
      : gpsTime.time
    : "--/--";

  return (
    <>
      <div className="fieldset-wrapper">
        <div className="legend-title main-legend-title">Блок датчиков {sensor?.model}</div>
        <section className="primary-clock">
          <div className="col-md-12 text-end">
            <UpdateButton
              loading={loading}
              onRefresh={getParams}
            />
          </div>
          <div className="row pt-1 align-items-center">
            <div className="col-md-2 mb-1">
              <InputGroup>
                <InputGroup.Addon>Влаж.</InputGroup.Addon>
                <Input value={params?.humidity} style={{textAlign: "center"}}/>
              </InputGroup>
            </div>
            <div className="col-md-2 mb-1">
              <InputGroup>
                <InputGroup.Addon>Давл.</InputGroup.Addon>
                <Input value={params?.pressure} style={{textAlign: "center"}}/>
              </InputGroup>
            </div>
            <div className="col-md-2 mb-1">
              <InputGroup>
                <InputGroup.Addon>Темп.</InputGroup.Addon>
                <Input value={params?.temperature} style={{textAlign: "center"}}/>
              </InputGroup>
            </div>
            <div className="col-md-3 mb-1">
              <InputGroup>
                <InputGroup.Addon>Время</InputGroup.Addon>
                <Input value={formattedGpsTime} style={{textAlign: "center"}}/>
              </InputGroup>
            </div>
            <div className="col-md-3 mb-1">
              <InputGroup>
                <InputGroup.Addon>Час. пояс</InputGroup.Addon>
                <Input value={gpsTime?.timeOffset || '--/--'} style={{textAlign: "center"}}/>
              </InputGroup>
            </div>

          </div>

          <div className="row mt-2 align-items-center">
            <div className="col-md-2 mb-1">
              <InputGroup>
                <InputGroup.Addon>Удары</InputGroup.Addon>
                <Input
                  readOnly={true}
                  value={shockCounter}
                  disabled={loading}
                />
              </InputGroup>
            </div>
            <div className="col-md-2 mb-1">
              <InputGroup>
                <InputGroup.Addon>Откр.</InputGroup.Addon>
                <Input
                  readOnly={true}
                  value={openCounter}
                  disabled={loading}
                />
              </InputGroup>
            </div>
            <div className="col-md-2 col-sm-12 text-center mt-1">
              <div className="d-flex align-items-center">
                <div className="relay-indicator me-2">
                  <StatusControl status={params?.doorReedSwitch ? "offline" : "online"}/>
                </div>
                <div className="relay-mode-value mt-0">
                  Дверь отк / зак
                </div>
              </div>

            </div>
            <div className="col-md-3 col-sm-12">
              <div className="d-flex align-items-center">
                <div className="me-2">
                  <div className="relay-indicator">
                    <StatusControl status={gpsCoordinates?.status === gpsStatus.none ? "offline" : "online"}/>
                  </div>
                </div>
                <div className="relay-mode-value mt-0">
                  {setStatus(gpsCoordinates?.status)}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-12">
              <p style={{color: '#666'}}>
                {gpsCoordinates?.coordinates || 'Нет данных о координатах'}
                <CopyIcon
                  onClick={() => SensorBlockUtils.handleCopyClick(gpsCoordinates?.coordinates ?? null)}
                  style={{cursor: 'pointer'}}
                  className="ms-2 mb-1"/>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-end">
              <a
                className="settings-link"
                href="#"
                onClick={(e) => {
                  navigate(`/devices/${deviceId}?tab=devices&externalId=${sensor?.id}`);
                  e.preventDefault();
                }}
              >
                <Whisper
                  placement="topStart"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={getTooltip('Перейти в настройки')}>
                <GearIcon className="gear-icon"></GearIcon>
                </Whisper>
              </a>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default SensorBlockSection;
